const state = {
    isMobile: window.innerWidth < 768,
    showFilters: false,
    showImageModal: false,
};

const mutations = {
    toggleFilters(state) {
        state.showFilters = !state.showFilters;
        window.scrollTo(0, 0);
    },

    toggleImageModal(state) {
        state.showImageModal = !state.showImageModal;
    },
};

export default {
    namespaced: true,
    mutations,
    state,
};
